export default __webpack_public_path__ + "static/media/maker3.62fd992f.png";